
export default {
    member: "/api/Member?", // 会员信息相关API
    getMemberKycAndLockStatus: "/api/Verification/GetMemberKycAndLockStatus?", // 获取KYC验证状态
    depositPaymentList: "/api/Payment/Methods?transactionType=Deposit&", // 返回平台开启的钱包列表
    depositDetail: "/api/Payment/Method/Details?transactionType=Deposit&", // 返回所选付款方式的详情
    getAmount: "/api/Payment/SuggestedAmounts?", // 获取建议充值金额
    wallets: "/api/Transfer/Wallets?",
    bonusApplications: "/api/Bonus/Applications?",
    calculate: "/api/Bonus/Calculate?",
    bonusList: "/api/Bonus?transactionType=",
    paymentConfirmStep: "/api/Payment/Application/ConfirmStep?", // 确认交易
    uploadAttachment: "/api/Payment/Applications/UploadAttachment?",
    memberBank: "/api/Payment/MemberBank?",
    memberBanks: "/api/Payment/MemberBanks?",
    updateMemberBank: "/api/Payment/UpdateMemberBank?",
    getWithdrawalbank: "/api/Payment/Method/Details?transactionType=Deposit&isMobile=false&Withdrawal&method=BQR&",

    withdrawalPaymentList: "/api/Payment/Methods?transactionType=Withdrawal&", // 返回平台开启的钱包列表
    withdrawalDetail: "/api/Payment/Method/Details?transactionType=Withdrawal&", // 返回所选提款方式的详情
    InsertNewAccountHolderName: "/api/Verification/AccountHolderName?",

    walletAddress: "/api/Payment/Cryptocurrency/WalletAddress",
    cryptoCurrencyDetails: "/api/Payment/Cryptocurrency/Details",
    exchangeRate: "/api/Payment/Cryptocurrency/ExchangeRate", // M2 获取或许有问题，换 /api​/Payment​/Cryptocurrency​/Details



    walletApplication: '/api/Payment/Application?', // 开始充值 or 提款
    SetDefault: "/api/Payment/MemberBank/SetDefault?",
}